import { NgModule } from '@angular/core';

import { AIAnnouncementModalService } from './ai-announcement-modal.service';

import { AIAnnouncementModalComponent } from './ai-announcement-modal.component';

@NgModule({
  imports: [AIAnnouncementModalComponent],
  providers: [AIAnnouncementModalService],
})
export class AIAnnouncementModalModule {}
